import { SMART_HOME_BASELOAD_REDUCTION, SMART_HOME_GROSS_USD, SMART_HOME_HVAC_REDUCTION } from './assumptions';
import { EnergyLoads, MeasureApplication, SimulationContext } from './types';

export const applySmartHome = (loads: EnergyLoads, _ctx: SimulationContext): MeasureApplication => {
  const keepHvac = 1 - SMART_HOME_HVAC_REDUCTION;
  const keepBaseload = 1 - SMART_HOME_BASELOAD_REDUCTION;

  return {
    loads: {
      ...loads,
      baseloadKwh: loads.baseloadKwh.map((kwh) => kwh * keepBaseload),
      coolingKwh: loads.coolingKwh.map((kwh) => kwh * keepHvac),
      fossilHeatUsd: loads.fossilHeatUsd.map((usd) => usd * keepHvac),
      heatingKwh: loads.heatingKwh.map((kwh) => kwh * keepHvac),
    },
    measureCost: {
      grossUsd: SMART_HOME_GROSS_USD,
      incentiveUsd: 0,
      measure: 'SMART_HOME',
      netUsd: SMART_HOME_GROSS_USD,
    },
  };
};
